import { CommonGetOptions } from "interfaces/dataInterfaces"
import { householdApi } from "./householdApi"

export const modalitiesApi = householdApi.injectEndpoints({
  endpoints: builder => ({
    getModalities: builder.query<CommonGetOptions[], void>({
      query: () => ({
        url: `SurveyModalities/Get`,
        method: "GET",
      }),
      providesTags: ["Modalities"],
    }),

    addModality: builder.mutation<void, { name: string }>({
      query: ({ name }) => ({
        url: `SurveyModalities/Add`,
        method: "POST",
        params: { name },
      }),
      invalidatesTags: ["Modalities"],
    }),

    editModality: builder.mutation<void, { id: number; name: string }>({
      query: ({ id, name }) => ({
        url: `SurveyModalities/Put/${id}`,
        method: "PUT",
        params: { name },
      }),
      invalidatesTags: ["Modalities"],
    }),

    deleteModality: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `SurveyModalities/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Modalities"],
    }),
  }),
})

export const {
  useGetModalitiesQuery,
  useLazyGetModalitiesQuery,
  useAddModalityMutation,
  useEditModalityMutation,
  useDeleteModalityMutation,
} = modalitiesApi
